import { observer } from "mobx-react";
import './onboarding-wizard.scss';
import OnboardingNavigation from "../onboarding-navigation/onboarding-navigation";
import OnboardingWizardStickyFooter from "../onboarding-wizard-sticky-footer/onboarding-wizard-sticky-footer";
import { IOnboardingStep } from "../../stores/onboarding-navigation-store";
import { useEffect } from "react";
import onboardingMixPanelStore from "../../stores/onboarding-mixpanel-store";

interface IOnboardingWizardProps {
    step: IOnboardingStep,
    children: React.ReactNode;
}

const OnboardingWizard: React.FC<IOnboardingWizardProps> = observer(({ step, children }) => {

    useEffect(() => {
        onboardingMixPanelStore.trackScreenView(step.name);
    }, [step.name]);

    return (
        <div className="onboarding-wizard-component">
            <OnboardingNavigation />
            <div className="onboarding-wizard-screen">
                {children}
            </div>
            <OnboardingWizardStickyFooter />
        </div>
    );
});

export default OnboardingWizard;